/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicationOcrRequestResponseDto
 */
export interface MedicationOcrRequestResponseDto {
    /**
     * OCR request ID
     * @type {string}
     * @memberof MedicationOcrRequestResponseDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof MedicationOcrRequestResponseDto
     */
    patientId: string;
    /**
     * File name
     * @type {string}
     * @memberof MedicationOcrRequestResponseDto
     */
    fileName: string;
    /**
     * Processing status
     * @type {string}
     * @memberof MedicationOcrRequestResponseDto
     */
    status: MedicationOcrRequestResponseDtoStatusEnum;
    /**
     * Processing start time
     * @type {Date}
     * @memberof MedicationOcrRequestResponseDto
     */
    startedAt?: Date;
    /**
     * Processing completion time
     * @type {Date}
     * @memberof MedicationOcrRequestResponseDto
     */
    completedAt?: Date;
    /**
     * Total medications extracted
     * @type {number}
     * @memberof MedicationOcrRequestResponseDto
     */
    totalExtracted?: number;
    /**
     * Total medications saved
     * @type {number}
     * @memberof MedicationOcrRequestResponseDto
     */
    totalSaved?: number;
    /**
     * Error message if failed
     * @type {string}
     * @memberof MedicationOcrRequestResponseDto
     */
    errorMessage?: string;
    /**
     * Processing metadata
     * @type {object}
     * @memberof MedicationOcrRequestResponseDto
     */
    metadata?: object;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof MedicationOcrRequestResponseDto
     */
    createdAt: Date;
}


/**
 * @export
 */
export const MedicationOcrRequestResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;
export type MedicationOcrRequestResponseDtoStatusEnum = typeof MedicationOcrRequestResponseDtoStatusEnum[keyof typeof MedicationOcrRequestResponseDtoStatusEnum];


/**
 * Check if a given object implements the MedicationOcrRequestResponseDto interface.
 */
export function instanceOfMedicationOcrRequestResponseDto(value: object): value is MedicationOcrRequestResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function MedicationOcrRequestResponseDtoFromJSON(json: any): MedicationOcrRequestResponseDto {
    return MedicationOcrRequestResponseDtoFromJSONTyped(json, false);
}

export function MedicationOcrRequestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicationOcrRequestResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'fileName': json['fileName'],
        'status': json['status'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'totalExtracted': json['totalExtracted'] == null ? undefined : json['totalExtracted'],
        'totalSaved': json['totalSaved'] == null ? undefined : json['totalSaved'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function MedicationOcrRequestResponseDtoToJSON(json: any): MedicationOcrRequestResponseDto {
    return MedicationOcrRequestResponseDtoToJSONTyped(json, false);
}

export function MedicationOcrRequestResponseDtoToJSONTyped(value?: MedicationOcrRequestResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'fileName': value['fileName'],
        'status': value['status'],
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'totalExtracted': value['totalExtracted'],
        'totalSaved': value['totalSaved'],
        'errorMessage': value['errorMessage'],
        'metadata': value['metadata'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

